import { AxiosError } from "axios";
import { deleteApi, getApi, getApiPdf, patchApi, postApi, putApi } from "../CreateApi";
import { GetResponseAttendance, GetResponseReport, ResponseAttendance, ResponseGetReportStudent } from "./interfaceAttendance";

export const postAttendance = async (body: any): Promise<ResponseAttendance> => {
    try {
        const data = await postApi('/attendance', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseAttendance;
    }
}


export const getAttendance = async (): Promise<GetResponseAttendance[]> => {
    try {
        const data = await getApi('/attendance/last-records');
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as GetResponseAttendance[];
    }
}


export const getAttendanceReports = async (params = {}): Promise<GetResponseReport[]> => {
    try {
        const data = await getApi('/attendance/by-classroom', params);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as GetResponseReport[];
    }
}


export const getAttendanceReportsId = async (id: number, params = {}): Promise<any> => {
    try {
        const data = await getApi(`/attendance/${id}`, params);

        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}


export const patchAttendanceReport = async (body: any, id?: number): Promise<any> => {
    try {
        const data = await patchApi(`/attendance/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getAttendanceReportStudent = async (params: any): Promise<ResponseGetReportStudent[]> => {
    try {
        const data = await getApi(`/enrollment/report`, params);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetReportStudent[];
    }
}

export const putChangeSectionEnrollment = async (params: any): Promise<any> => {
    try {
        const data = await putApi(`/enrollment/change-section/${params.studentId}/classroom/${params.activityClassroomId}`, {});
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetReportStudent[];
    }
}

export const postTransfersStudent = async (body: any): Promise<any> => {
    try {
        const data = await postApi(`/transfers`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetReportStudent[];
    }
}

export const deleteTransfersStundet = async (term: number): Promise<any> => {
    try {
        const data = await deleteApi(`/transfers/${term}`, term);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}


export const getAllTransfers = async ({ levelId, campusId, yearId }: { levelId?: string, campusId?: string, yearId?: string }): Promise<any[]> => {
    try {
        const data = await getApi(`/transfers`, { levelId, campusId, yearId });
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any[];
    }
}

export const postTransfersMeetings = async ({ body }: { body: any }): Promise<any> => {
    try {
        const data = await postApi(`/transfers/meetings`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getAllTransfersMeetings = async (id: number): Promise<any[]> => {
    try {
        const data = await getApi(`/transfers/meetings/request/${id}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any[];
    }
}

export const patchTransfersMeetings = async ({ body, id }: { body: any, id?: number }): Promise<any> => {
    try {
        const data = await patchApi(`/transfers/meetings/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const deleteTransfersMeetings = async (id: number): Promise<any> => {
    try {
        const data = await deleteApi(`/transfers/meetings${id}`, {});
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const postTransfersReport = async ({ body }: { body: any }): Promise<any> => {
    try {
        const data = await postApi(`/transfers/report`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getAllTransfersReport = async ({ id }: { id: number }): Promise<any> => {
    try {
        const data = await getApi(`/transfers/report/request/${id}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}


export const deleteTransfersReports = async (id: number): Promise<any> => {
    try {
        const data = await deleteApi(`/transfers/report/${id}`, {});
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const patchTransfersReports = async ({ body, id }: { body: any, id?: number }): Promise<any> => {
    try {
        const data = await patchApi(`/transfers/report/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const postTransfersAct = async ({ body, id }: { body: any, id: number }): Promise<any> => {
    try {
        const data = await postApi(`/transfers/${id}/upload-agreement-act`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getAllTranferStatus = async ({ id }: { id: number }): Promise<any> => {
    try {
        const data = await getApi(`/transfers/status/${id}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getAllTranferMyMeetings = async (): Promise<any> => {
    try {
        const data = await getApi(`/transfers/all/my-meetings`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getReportFlow = async (params: any): Promise<any> => {
    try {
        const data = await getApi(`/transfers/reports/flow`, params);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getAttendanceReportExcel = async (month: number, activityClassroomIds: number[]): Promise<any> => {
    try {
        const params = {
            month,
            activityClassroomIds
        }
        const data = await getApiPdf('/attendance/report/excel', params);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}